import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import laurelLeading from '../assets/images/laurel-leading.png';
import laurelTrailing from '../assets/images/laurel-trailing.png';

// Sterling's own bar. Structurally the Panda Taps navbar this page used to sit
// under — same height, same blur, same scrolled treatment — but the studio's
// five-app nav has nothing to say on a single-product site, so the links are
// Sterling's own documents and the mark is the laurel rather than the panda.
const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 68px;
  z-index: 9999;
  display: flex;
  align-items: center;
  background: ${({ $scrolled }) =>
    $scrolled ? 'rgba(248, 244, 238, 0.97)' : 'rgba(248, 244, 238, 0.9)'};
  backdrop-filter: saturate(160%) blur(14px);
  -webkit-backdrop-filter: saturate(160%) blur(14px);
  border-bottom: 1px solid ${({ $scrolled }) => ($scrolled ? 'rgba(28,28,28,0.10)' : 'rgba(28,28,28,0.06)')};
  box-shadow: ${({ $scrolled }) => ($scrolled ? '0 6px 24px rgba(28,28,28,0.06)' : 'none')};
  transition: background .3s ease, border-color .3s ease, box-shadow .3s ease;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
`;

const Brand = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #1C1C1C;
  font-family: 'Crimson Pro', Georgia, serif;
  font-weight: 700;
  font-size: 1.32rem;
  letter-spacing: -0.01em;
  text-decoration: none;
`;

const Laurel = styled.img`
  height: 20px;
  width: auto;
  opacity: 0.85;
  pointer-events: none;
`;

const Links = styled.div`
  display: flex;
  align-items: center;
  gap: 1.9rem;
  @media (max-width: 680px) { gap: 1.1rem; }
`;

const NavItem = styled(Link)`
  font-family: var(--font-body);
  font-weight: 500;
  font-size: 0.96rem;
  color: #6B6259;
  text-decoration: none;
  transition: color .2s ease;

  &:hover { color: #1C1C1C; }

  @media (max-width: 480px) {
    &:nth-child(2) { display: none; }
  }
`;

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Nav $scrolled={scrolled}>
      <Container>
        <Brand to="/" aria-label="Sterling — home">
          <Laurel src={laurelLeading} alt="" aria-hidden="true" />
          Sterling
          <Laurel src={laurelTrailing} alt="" aria-hidden="true" />
        </Brand>
        <Links>
          <NavItem as="a" href="/support/sterling.html">Support</NavItem>
          <NavItem as="a" href="/legal/sterling-privacy.html">Privacy</NavItem>
          <NavItem as="a" href="/legal/sterling-terms.html">Terms</NavItem>
        </Links>
      </Container>
    </Nav>
  );
}
